<template>
    <component :is="component" v-if="isRouterLink" :class="classes" v-bind="props" @click.native="emitEvent">
        <slot />
    </component>
    <component :is="component" v-else :class="classes" v-bind="props" @click="emitEvent">
        <slot />
    </component>
</template>

<script>
import './scc-link.scss';

export default {
    name: 'SccLink',
    props: {
        tag: {
            type: String,
            default: 'a',
            validator: function(val) {
                return ['a', 'button'].includes(val);
            },
        },
        to: {
            type: [String, Object],
            default: '',
        },
        target: {
            type: String,
            default: '_self',
            validator: function(val) {
                return ['_blank', '_parent', '_self', '_top'].includes(val);
            },
        },
        align: {
            type: String,
            validator: function(val) {
                return ['start', 'center', 'end'].includes(val);
            },
        },
        button: {
            type: Boolean,
            required: false,
            default: false,
        },
        large: {
            type: Boolean,
            required: false,
            default: false,
        },
        xlarge: {
            type: Boolean,
            required: false,
            default: false,
        },
        color: {
            type: String,
            required: false,
            validator: function(val) {
                return ['primary', 'secondary'].includes(val);
            },
        },
        inverted: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        component() {
            if (this.isExternalLink || this.isRootLink) {
                return this.tag;
            }

            return 'router-link';
        },
        isRouterLink() {
            return this.component === 'router-link';
        },
        classes() {
            return [
                {
                    'scc-link--button': this.button,
                    'scc-link--inverted': this.inverted,
                    [`scc-link--${this.color}`]: this.color,
                    'scc-link--large': this.large,
                    'scc-link--xlarge': this.xlarge,
                    [`scc-link--align-${this.align}`]: this.align,
                    'scc-link--disabled': this.disabled,
                },
            ];
        },
        props() {
            const props = { target: this.resolvedTarget };

            if (this.isRouterLink) {
                props.to = this.resolvedTo;
            } else {
                props.href = this.to;
            }

            return props;
        },
        mock() {
            return !!this.$editor && this.isRootLink;
        },
        toIsString() {
            return typeof this.to === 'string';
        },
        isExternalLink() {
            return this.toIsString && this.to.startsWith('http') && !this.to.includes(window.location.origin);
        },
        isRootLink() {
            return this.toIsString && this.to.startsWith('/');
        },
        isHashLink() {
            return this.toIsString && this.to.startsWith('#');
        },
        resolvedTo() {
            if (this.to && this.toIsString && !this.isHashLink) {
                return { name: 'Page', params: { path: this.to } };
            }

            return this.to;
        },
        resolvedTarget() {
            return this.isExternalLink ? '_blank' : this.target;
        },
    },
    methods: {
        emitEvent(event) {
            if (this.mock) {
                event.preventDefault();
                event.stopPropagation();

                const message =
                    `This link doesn't work in the editor, because it starts with a "/". \n\n` +
                    `If you are trying to link to a page of another game you can safely ignore this message. ` +
                    `Otherwise remove the leading slash, and try again. \n\n` +
                    `Link: \n` +
                    ` - ${this.to}`;

                alert(message);
            }

            this.$emit('click', event);
        },
    },
};
</script>
